import { DeviceBreakpointsTypeUtils } from '../../../types/breakpoints/breakpoints';
export const onlyDesktopSize = (device, value) => {
    return DeviceBreakpointsTypeUtils.isDesktopOrLargeDesktop(device) ? value : undefined;
};
//# sourceMappingURL=onlyDesktopSize.js.map